module.exports = __webpack_public_path__ + "static/img/activity-score-notice-character.0c8920c.png";